var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mode !== '')?_c(_vm.templateNameSuffix,{tag:"div",attrs:{"form":_vm.form},on:{"toggleIsRegistering":function($event){return _vm.$emit('toggleIsRegistering')}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }